import { distanceFromLit } from "./googlemaps";

// We don't store the mapkit instance in redux. Instead 
// we store it statically here.
let mapkitinstance = null;

export function setMapKit(mapkit){
    mapkitinstance = mapkit;
}

export function getMapKit() {
    return mapkitinstance;
}

export function mapKitToGoogleLatLngLit(coord): google.maps.LatLngLiteral {
    return {
        lat: coord.latitude, lng: coord.longitude
    }
}

function GetPointAtDistance(points: Array<google.maps.LatLngLiteral>, metres: number): google.maps.LatLngLiteral {
    // some awkward special cases
    if (points.length === 0) {
        return null;
    }
    if (metres === 0 || points.length == 1) {
        return points[0];
    }
    if (metres < 0) {
        return null;
    }
    let dist = 0;
    let olddist = 0;
    for (var i = 1; (i < points.length && dist < metres); i++) {
        olddist = dist;
        dist += distanceFromLit(points[i], points[i - 1]);
    }
    if (dist < metres) {
        return null;
    }
    const p1 = points[i - 2];
    const p2 = points[i - 1];
    const m = (metres - olddist) / (dist - olddist);
    //console.log("Between points:");
    //console.log(p1);
    //console.log(p2);

    // can use google.maps.geometry.spherical.interpolate
    // https://developers.google.com/maps/documentation/javascript/reference/geometry
    return {
        lat: p1.lat + (p2.lat - p1.lat) * m,
        lng: p1.lng + (p2.lng - p1.lng) * m
    };
}


// Convert the path into a simple list of latlngs that we can walk down.
function getLatLngsFromSteps(steps: Array<any>): Array<google.maps.LatLngLiteral> {
    let latlngs: Array<google.maps.LatLngLiteral> = [];
    let lastcoord = null;
    for (const step of steps) {
        for (const pathitem of step.path) {
            if (lastcoord == null || !pathitem.equals(lastcoord)) {
                latlngs.push(mapKitToGoogleLatLngLit(pathitem));
                lastcoord = pathitem;
            }
        }
    }
    return latlngs;
}

// Gets the midpoint of a map route
export function getMidPoint(route): google.maps.LatLngLiteral {
    const distance = route.distance;
    const items = getLatLngsFromSteps(route.steps);
    //console.log(items);
    
    return GetPointAtDistance(items, distance / 2);
    
}